import { render, staticRenderFns } from "./ServiceItem.vue?vue&type=template&id=3f5486b7&scoped=true&"
import script from "./ServiceItem.vue?vue&type=script&lang=ts&"
export * from "./ServiceItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5486b7",
  null
  
)

export default component.exports